import React from 'react';
import {
  Mail,
  MoreVertical,
  Trash2,
  Archive,
  Clock,
  Wifi,
  Battery,
  ChevronLeft
} from 'lucide-react';
import './EmailPreviewFrame.css';

const EmailPreviewFrame = ({ html, mode = 'desktop' }) => {
  if (mode === 'mobile') {
    return (
      <div className="phone-frame">
        <div className="phone-header">
          <div className="phone-notch"></div>
          <div className="phone-status-bar">
            <span className="phone-time">9:41</span>
            <div className="phone-status-icons">
              <Wifi size={12} />
              <Clock size={12} />
              <Battery size={12} />
            </div>
          </div>
        </div>
        <div className="phone-screen">
          <div className="mobile-email-header">
            <div className="mobile-toolbar">
              <button className="mobile-back"><ChevronLeft size={24} /></button>
              <div className="mobile-actions">
                <button><Archive size={20} /></button>
                <button><Trash2 size={20} /></button>
                <button><MoreVertical size={20} /></button>
              </div>
            </div>
            <div className="mobile-email-meta">
              <div className="mobile-sender">
                <div className="mobile-avatar">K</div>
                <div className="mobile-sender-info">
                  <div className="mobile-sender-name">KNKT</div>
                  <div className="mobile-sender-email">noreply@knkt.io</div>
                </div>
              </div>
              <div className="mobile-subject">Your Email Preview</div>
            </div>
          </div>
          <div className="mobile-email-body">
            <iframe
              key={html.substring(0, 100)}
              srcDoc={html}
              title="Email Preview Mobile"
              className="preview-iframe mobile"
            />
          </div>
        </div>
        <div className="phone-bottom-bar"></div>
      </div>
    );
  }

  // Desktop Gmail view - Dark theme, full-page with centered content
  return (
    <div className="gmail-frame-fullpage">
      <div className="gmail-header">
        <div className="gmail-logo">
          <Mail size={20} />
          <span>Gmail</span>
        </div>
        <div className="gmail-search">
          <input type="text" placeholder="Search mail" readOnly />
        </div>
        <div className="gmail-avatar">K</div>
      </div>

      <div className="gmail-content-wrapper">
        <div className="gmail-sidebar">
          <button className="gmail-compose">+ Compose</button>
          <div className="gmail-nav">
            <div className="gmail-nav-item active">
              <Mail size={18} />
              <span>Inbox</span>
              <span className="gmail-count">12</span>
            </div>
            <div className="gmail-nav-item">
              <Archive size={18} />
              <span>Starred</span>
            </div>
            <div className="gmail-nav-item">
              <Trash2 size={18} />
              <span>Trash</span>
            </div>
          </div>
        </div>

        <div className="gmail-main-centered">
          <div className="gmail-email-container">
            <div className="gmail-email-header">
              <div className="gmail-email-subject">
                <h2>Your Email Preview</h2>
                <span className="gmail-label">Promo</span>
              </div>
              <div className="gmail-toolbar">
                <button title="Archive"><Archive size={18} /></button>
                <button title="Delete"><Trash2 size={18} /></button>
                <button title="More"><MoreVertical size={18} /></button>
              </div>
            </div>

            <div className="gmail-email-meta">
              <div className="gmail-sender-info">
                <div className="gmail-sender-avatar">K</div>
                <div className="gmail-sender-details">
                  <div className="gmail-sender-name">KNKT</div>
                  <div className="gmail-sender-email">
                    to me
                    <span className="gmail-sender-email-full">noreply@knkt.io</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="gmail-email-body">
              <iframe
                key={html.substring(0, 100)}
                srcDoc={html}
                title="Email Preview Desktop"
                className="preview-iframe desktop"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailPreviewFrame;
